import React, { useEffect, useMemo, useState } from "react";
import { useIntl } from "react-intl";

import {
  Button,
  Input,
  Form,
  FormField,
  FormGroup,
  Modal,
  ModalContent,
  Segment,
} from "semantic-ui-react";

// Interface
import {
  RunSequence,
} from "./sequence/WorkSchedule";

// type
type ModConfirmRejectRequestProps = {
  // open: boolean;
  // onClose: () => void;
  // id: number;
  // rejectRemark: string;
  // setRejectRemark: (val: string) => void;
  // setShowRejectModal: (val: boolean) => void;
  // runSequence: RunSequence;
  open: boolean;
  onClose: () => void;
  onConfirmReject: (data: { id: number; remark: string }) => void;
  id: number;
  title?: string;
  label?: string;
  confirmText?: string;
};

const ModConfirmRejectRequest = ({
  open,
  onClose,
  onConfirmReject,
  id,
  title = "Alert Message",
  label = "Please specify the reason for rejection",
  confirmText = "CONFIRM REJECTING",
}: ModConfirmRejectRequestProps) => {

  const [remark, setRemark] = useState<string>("");
  // const intl = useIntl();

  useEffect(() => {
    if (open) setRemark("");
  }, [open]);

  return (
    <Modal
      open={open}
      onClose={onClose}
      size="tiny"
    >
      <Segment id="ModConfirmRejectRequest-Segment-Title" inverted color="red">
        {title}
      </Segment>
      <ModalContent>
        <Form>
          <FormGroup style={{ display: "flex", justifyContent: "center" }}>
            <FormField>
              <label>{label}</label>
            </FormField>
          </FormGroup>
          <FormGroup style={{ display: "flex", justifyContent: "center" }}>
            <FormField width={14}>
              <Input
                id="ModConfirmRejectRequest-Input-Remark"
                value={remark || ""}
                onChange={(e, { value }) => setRemark(value as string)}
              />
            </FormField>
          </FormGroup>
          <FormGroup style={{ display: "flex", justifyContent: "center" }}>
            <FormField inline>
              <Button
                id="ModConfirmRejectRequest-Button-Reject"
                basic
                color="green"
                disabled={!remark?.trim()}
                onClick={() => onConfirmReject({ id, remark })}
              >
                {confirmText}
              </Button>
              <Button
                id="ModConfirmRejectRequest-Button-Close"
                basic
                color="red"
                onClick={onClose}
              >
                CLOSE
              </Button>
            </FormField>
          </FormGroup>
        </Form>
      </ModalContent>
    </Modal>
  )
};

export default ModConfirmRejectRequest;